import React, { useEffect, useRef, useState } from 'react';
import useReveal from './useReveal';

// Animated number that eases up from 0 when it scrolls into view.
// Accepts `value` (number), optional `prefix` / `suffix` strings and `decimals`.
export default function CountUp({ value, prefix = '', suffix = '', decimals = 0, duration = 1600 }) {
  const [ref, revealed] = useReveal(0.4);
  const [display, setDisplay] = useState(0);
  const rafRef = useRef(0);

  useEffect(() => {
    if (!revealed) return undefined;
    if (
      typeof window !== 'undefined' &&
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ) {
      setDisplay(value);
      return undefined;
    }
    const start = performance.now();
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplay(value * eased);
      if (t < 1) {
        rafRef.current = window.requestAnimationFrame(tick);
      }
    };
    rafRef.current = window.requestAnimationFrame(tick);
    return () => window.cancelAnimationFrame(rafRef.current);
  }, [revealed, value, duration]);

  const formatted = display.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });

  return (
    <span ref={ref} className="pl-countup">
      {prefix}
      {formatted}
      {suffix}
    </span>
  );
}
